export default __webpack_public_path__ + "static/thumnail_blog_default-3c965014517f0a5a04aa6fe3dd000e4f.png";